import ImagePickerModal from "./ImagePickerModal";

export default ImagePickerModal;